import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs';

import { AuthenticationService, USER_TYPES } from '../../../authorization/authentication.service';
import { chekcPermissionFunc } from '../../base-functions/permission.base-functions';
import { ACToasterService } from '../../services/ac-toaster.service';

@Injectable()
export class GuardSUPER_ADMIN_P implements CanActivate {

    constructor(
        private route: Router,
        private serviceAuthentication: AuthenticationService,
        private serviceACToaster: ACToasterService
    ) { }

	/**
	 * Validate if user is logged in. If not, redirect to Login page
	 * @param route
	 * @param state
	 * @returns {boolean}
	 */
    public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
        try {
            const currentUser = this.serviceAuthentication.currentUserValue;
            const result = chekcPermissionFunc(currentUser, USER_TYPES.SUPER_ADMIN);
            if(!result)
                this.serviceACToaster.showPermissionWarning();

            return result;
        } catch (error) {
            return false;
        }
    }
}
